import { jsx as i } from "react/jsx-runtime";
import { Breakpoints as t, ImageWithOptionalCTA as m } from "@nextgen-web-framework/all";
import '../../assets/ImageWithOptionalCTA.css';const b = "#ffffff", R = "#396e75", B = "#e5fdff", p = "#546223", O = "#f0fae5", w = "#a65523", G = "#fff1e8", W = "#7f3e3e", y = "#ffe2e2", _ = "#62625a", v = "#f8f8e7", I = "#38539a", P = "#707070", A = "#c8f8d1", N = "#87c9c8", S = "#5291b1", Y = "rgba(82, 145, 177, 0.1019607843)", L = "#445685", x = "#181d61", E = "rgba(24, 29, 97, 0.1019607843)", M = "#5969d6", T = "#ea999d", X = "#b6577e", j = "rgba(182, 87, 126, 0.1019607843)", D = "#7e3e80", q = "#1e247f", F = "rgba(30, 36, 127, 0.1019607843)", H = "#da7600", J = "#107f47", K = "#d91734", Q = "12", U = "12", Z = "_html_1acvb_38", d = {
  amwayWhite: b,
  darkBlue: R,
  lightBlue: B,
  darkGreen: p,
  lightGreen: O,
  darkOrange: w,
  lightOrange: G,
  darkRed: W,
  lightRed: y,
  darkYellow: _,
  lightYellow: v,
  darkPurple: I,
  darkGrayOnWhite: P,
  dataVizColor1: A,
  dataVizColor2: N,
  dataVizColor3: S,
  dataVizColor3Background: Y,
  dataVizColor4: L,
  dataVizColor5: x,
  dataVizColor5Background: E,
  dataVizColor6: M,
  dataVizColor7: T,
  dataVizColor8: X,
  dataVizColor8Background: j,
  dataVizColor9: D,
  dataVizColor10: q,
  dataVizColor10Background: F,
  dataVizAlertOrange: H,
  dataVizSuccessGreen: J,
  dataVizWarningRed: K,
  roundedImageRadius: Q,
  roundedContainerRadius: U,
  "no-visible": "_no-visible_1acvb_34",
  html: Z
}, oa = (l) => {
  const { bgColor: c, button: r, link: a, config: s, imgList: g, rounded: u } = l, o = {
    src: "",
    alt: "",
    borderRadius: 0,
    width: 0
  }, e = {
    [t.XS]: o,
    [t.SM]: o,
    [t.MD]: o,
    [t.LG]: o,
    [t.XL]: o
  };
  g.forEach(({ alt: C, image_file: V, viewport: z, width: f }) => {
    const h = {
      alt: C,
      src: V.url,
      borderRadius: s.rounded ? Number(d.roundedImageRadius) : 0,
      width: f
    };
    z.forEach((k) => e[k] = h);
  });
  const n = {
    className: "",
    containerBorderRadius: u ? Number(d.roundedContainerRadius) : 0,
    bgColor: c,
    imgPerViewport: e,
    button: r != null && r.title ? r : void 0
  };
  return a != null && a.url && (n.ctaConfig = {
    href: a.url,
    target: a.target ?? "_blank"
  }), /* @__PURE__ */ i("div", { className: d["image-with-optional-cta-container"], children: /* @__PURE__ */ i(m, { ...n }) });
};
export {
  oa as default
};
//# sourceMappingURL=ImageWithOptionalCTA.js.map
